module.exports = __webpack_public_path__ + "static/visionPoster2-1-994b29a44e20c5131cffdd92a4a2a3a0.jpg";